// DAS-3319: the pass mark per account as one short label ("PASS" / "FAIL") for the
// "Which part pulled which way" rows, with the rule and today's figure for the hover.
// The backend sentence (advice_sleeve_passmarks.evaluate) reads
// "<account>: <rule>; today <gap>: <STATUS>" — it also feeds the advice prompt, so it is
// trimmed here instead of changed there.

// The hover text: the rule without the internal account key and the repeated status.
export function passmarkHover(pm) {
  if (!pm || !pm.text) return '';
  let s = String(pm.text).trim();
  const prefix = `${pm.account}: `;
  if (pm.account && s.startsWith(prefix)) s = s.slice(prefix.length);
  s = s.replace(/:\s*(PASS|FAIL)\s*$/, '');
  const parts = s.split('; today ');
  if (parts.length !== 2) return s;
  return `Your rule for this account (strategy, section 15): ${parts[0]}. Today: ${parts[1]}.`;
}

// { label, kind, hover }. kind: 'g' (pass), 'r' (fail), 'n' (no pass mark / unknown status).
export function passmarkChip(pm) {
  if (!pm) return { label: 'none', kind: 'n', hover: 'No pass mark set for this account.' };
  const kind = pm.status === 'PASS' ? 'g' : pm.status === 'FAIL' ? 'r' : 'n';
  return { label: pm.status || '—', kind, hover: passmarkHover(pm) };
}

export default passmarkChip;
